import React from 'react';
const Footer = () => {
  return <footer className="bg-[#c19a3c] text-white py-16 px-6 md:px-12 lg:px-24" data-id="element-46">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12" data-id="element-47">
        <div data-id="element-48">
          <h3 className="text-2xl font-serif mb-6" data-id="element-49">About Us</h3>
          <address className="not-italic" data-id="element-50">
            <p data-id="element-51">3410 Mid Court Rd Ste 119</p>
            <p data-id="element-52">Carrollton Texas 75006</p>
          </address>
        </div>
        <div data-id="element-53">
          <h3 className="text-2xl font-serif mb-6" data-id="element-54">Contact Us</h3>
          <p data-id="element-55">info@mavericklegacy.org</p>
        </div>
        <div data-id="element-56">
          <h3 className="text-2xl font-serif mb-6" data-id="element-57">Follow Us</h3>
          <ul className="space-y-2" data-id="element-58">
            <li data-id="element-59">
              <a href="https://www.instagram.com/mavericklegacyfoundation/" target="_blank" rel="noopener noreferrer" className="underline hover:no-underline" data-id="element-60">
                Instagram
              </a>
            </li>
          </ul>
        </div>
        <div data-id="element-61">
          <h3 className="text-2xl font-serif mb-6" data-id="element-62">Newsletter</h3>
          <p className="mb-6" data-id="element-63">
            Stay informed about new initiatives, volunteer opportunities, and
            inspiring success stories. Subscribe to receive curated updates
            delivered straight to your inbox.
          </p>
          <div className="space-y-4" data-id="element-64">
            <input type="email" placeholder="Email Address" className="w-full bg-white text-black px-4 py-3 focus:outline-none" data-id="element-65" />
            <button type="button" className="bg-white text-[#c19a3c] px-8 py-3 rounded-full font-medium hover:bg-opacity-90 transition-all" data-id="element-66">
              Sign Up
            </button>
          </div>
        </div>
      </div>
    </footer>;
};
export default Footer;